import React, { useEffect } from "react";
import About from "./components/About";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import OurTeam from "./components/OurTeam";
import Plan from "./components/plans/Plan";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Helmet } from "react-helmet";

/* ── IntersectionObserver scroll-reveal ── */
function useScrollReveal() {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      document.querySelectorAll(".reveal").forEach((el) => {
        el.classList.add("visible");
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}

function App() {
  useScrollReveal();

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>GetNet — Internet Service Provider | Kopar Khairane</title>
        <link rel="canonical" href="https://getnet.online" />
        <meta
          name="description"
          content="GetNet provides lightning-fast fiber broadband internet plans in Kopar Khairane and Ghansoli, Navi Mumbai. 10 Mbps to 300 Mbps unlimited plans with 350+ live TV channels and 22+ OTT apps."
        />
        <meta name="theme-color" content="#000000" />
      </Helmet>

      <Navbar />
      <Hero />
      <Plan />
      <About />
      <OurTeam />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
